import React, { useState, useEffect } from "react";
import useApi from '../hooks/useApi';
import UserService from "../services/user.service";
import HeaderTherapist from './HeaderTherapist';
import useAuth from '../hooks/useAuth'; import Informations from './Informations';
import Header from './Header';
import user from '../assets/images/default.png';
import ReviewList from './ReviewList';
import { useNotifications } from '../context/NotificationProvider';
import { useNavigate, useLocation } from 'react-router-dom';
import Modal from "react-modal";
import croix from "../assets/images/close-black.png";
import UnavailableZoneService from '../services/unavailable_zones.service';
import DomainService from '../services/domain.service';
import { usePrompt } from '../hooks/usePrompt';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import FlyproCardMetadata from './FlyproCardMetadata';


const customStyles = {
    content: {
        width: "33%",
        top: "50%",
        padding: "40px",
        left: "50%",
        right: "auto",
        bottom: "auto",
        borderRadius: "10px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        maxWidth: "450px",
        margin: "auto",
        textAlign: "center",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
    },
};

const EDIT_STEP_PATHS = [
    '/location-pro',
    '/fav-flypro',
    '/flypro-service',
    '/flypro-booking',
    '/payment'
];

const EDIT_SESSION_KEYS = [
    "editBookingMode",
    "editAddressMode",
    "modificationBookingId",
    "oldBooking",
    "newBooking",
    "productChanged",
    "therapistChanged",
    "addressChanged",
    "bookingToEdit",
    "state",
    "address"
];


Modal.setAppElement("#root");

const FavFlyPro = () => {
    const location = useLocation();
    const savedProState = location.state || JSON.parse(sessionStorage.getItem('state') || '{}');
    const { t } = useTranslation('fav');
    const [therapists, setTherapists] = useState([]);
    const [address, setAddress] = useState(null);
    const [selectedTherapist, setSelectedTherapist] = useState(() =>
        savedProState.origin_flow === 'pro' && Array.isArray(savedProState.selectedTherapist)
            ? savedProState.selectedTherapist
            : []);
    const { auth } = useAuth();
    const api = useApi();
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(25);
    const [filters, setFilters] = useState({
        with: 'primary_address,zones,media,categories,slots',
        page: currentPage,
        per_page: perPage,
        sort: 'firstname'
    });
    const navigate = useNavigate();
    const notify = useNotifications();
    const [phone, setPhone] = useState(null);
    const [modalIsOpenService, setIsOpenService] = useState(false);
    const [email, setEmail] = useState("");

    const [currentTherapist, setCurrentTherapist] = useState('');
    const [modalIsOpen2, setIsOpen2] = useState(false);

    const closeModalservice = () => setIsOpenService(false);
    const openModalservice = () => {

        setIsOpenService(true)
    };
    const onContact = () => {
        navigate('/contact');
    };


    const fetchTherapistWithRatings = async (therapistId) => {
        const res = await UserService.indexByRole(
        {
            id: therapistId,
            with: 'media,categories,ratings,ratings.creator.media',
        },
        'ROLE_FLYPRO',
        api,
        true
        );

        return Array.isArray(res) ? res[0] : res;
    };

    const openModal2 = async (therapist) => {
        console.log(therapist)
        setCurrentTherapist(therapist)
        setIsOpen2(true)
        try {
        const full = await fetchTherapistWithRatings(therapist.id);
        if (full) setCurrentTherapist(full);
        } catch (e) {
        console.error("Failed to load therapist ratings:", e);
        }
    };
    const closeModal2 = () => setIsOpen2(false);

    const isEditBookingMode = sessionStorage.getItem("editBookingMode") === "true" || location?.state?.fromEditBooking;

    // Use `usePrompt` for navigation blocking
    usePrompt(
        isEditBookingMode,
        "Êtes-vous sûr de vouloir quitter la modification ? Vos changements ne seront pas enregistrés.",
        next => EDIT_STEP_PATHS.some(p => next.pathname.startsWith(p))
    );



    const fetchTherapists = async (savedAddress) => {
        try {
            const therapistResponse = await UserService.indexByRole(
                { ...filters, status: "ACTIVE" },
                'ROLE_FLYPRO',
                api,
                auth.user ? false : true
            );

            const addressZip = savedAddress?.address?.zip_code || savedAddress?.zip_code ||
                JSON.parse(savedAddress)?.address?.zip_code ||
                null;


            if (addressZip) {
                const zipNum = parseInt(addressZip, 10);

                const filteredTherapists = therapistResponse.data.filter((therapist) => {
                    if (!therapist.zones || therapist.zones.length === 0) {
                        console.log(`Therapist ${therapist.firstname} has no zones`);
                        return false;
                    }

                    return therapist.zones.some(zone => {
                        if (!zone.zip_code) {
                            console.log(`Zone ${zone.id} has no zip_code`);
                            return false;
                        }

                        console.log(`Checking zone with zip_code: ${zone.zip_code}`);

                        const ranges = zone.zip_code.split(',');

                        return ranges.some(range => {
                            if (!range.includes('-')) {
                                const singleZip = parseInt(range.trim(), 10);
                                return singleZip === zipNum;
                            }

                            const [startStr, endStr] = range.split('-').map(s => s.trim());
                            const start = parseInt(startStr, 10);
                            const end = parseInt(endStr, 10);

                            if (isNaN(start) || isNaN(end)) {
                                console.warn(`Invalid zip range: ${range}`);
                                return false;
                            }

                            return zipNum >= start && zipNum <= end;
                        });
                    });
                });

                setTherapists(filteredTherapists);
                const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
                const booking = JSON.parse(sessionStorage.getItem("oldBooking"));
                if (isEditMode && !selectedTherapist.length && (booking?.therapists ?? []).length > 0) {
                    const therapistIds = new Set(filteredTherapists.map(o => o.id));
                    const selectedTherapistIds = booking.therapists.map(o => o.id) ?? [];
                    if (selectedTherapistIds.every(id =>
                        therapistIds.has(id))) {
                        setSelectedTherapist(filteredTherapists.filter((therapist) => therapist.id === booking.therapists[0].id))
                    }
                }
            } else {
                console.log("No address zip code, showing all therapists");
                setTherapists(therapistResponse.data);
            }
        } catch (error) {
            console.error("Error while fetching therapists:", error);
        }
    };

    function isZipCodeInRange(zipCode, range) {
        const ranges = range.split(',');
        const zip = parseInt(zipCode, 10);

        for (let element of ranges) {
            const trimmedElement = element.trim();

            if (trimmedElement.includes('-')) {
                const [start, end] = trimmedElement.split('-').map(Number);
                if (zip >= start && zip <= end) {
                    return true;
                }
            } else {
                const singleZip = parseInt(trimmedElement, 10);
                if (zip === singleZip) {
                    return true;
                }
            }
        }

        return false;
    }

    const handleSubmitEmail = async (e) => {
        e.preventDefault();

        const payload = {
            email: email,
            zip_code: address.zip_code,
            user_id: auth?.user?.id || null,
            zone_id: auth?.user?.id || null
        };
        console.log('payload', payload)

        try {
            const response = await UnavailableZoneService.store(payload, api);

            if (response.success) {
                notify.success('Votre zone a été ajoutée avec succès');
            }
        } catch (error) {
            console.error('Error submitting email:', error);
        }
    };

    const fetchAllDomains = async () => {
        try {
            console.log('infossss innnn');


            if (!selectedTherapist) {
                console.warn('No therapist selected');
                return;
            }

            const domainIds = [...new Set(selectedTherapist[0].categories.map(cat => cat.domain_id).filter(id => id !== null))];
            console.log('Fetching domains for unique category IDs:', domainIds);

            const domainResponses = await Promise.all(
                domainIds.map(id =>
                    api.get(`/domains/public/${id}`, {
                        params: {
                            with: 'media',
                        },
                        headers: { Authorization: `Bearer ${auth?.accessToken}` },
                    })
                )
            );

            const filteredDomains = domainResponses.map(response => response.data);


            console.log({ filteredDomains });

            return filteredDomains;

        } catch (error) {
            console.error("Error fetching domains:", error);
        }
    };

    const handleSubmit = async (event) => {
        event?.preventDefault();

        const isEditingSequential = sessionStorage.getItem("editingSequential") === "true";

        if (isEditingSequential) {
            // For sequential bookings, only allow 1 therapist
            const selectedTherapists = selectedTherapist;
            if (selectedTherapists.length !== 1) {
                notify.warn(t('please_select_a_flypro'));
                return;
            }

            const paymentState = {
                selectedTherapist: selectedTherapists,
                address,
                phone,
                origin_flow: 'pro',
                duo: false, // Sequential is not DUO
            };
            console.log('fypro2 sequential', paymentState);
            sessionStorage.setItem('state', JSON.stringify(paymentState));

            // Handle sequential booking navigation
            navigate('/payment', { state: paymentState });
            return;
        }

        const selectedTherapists = selectedTherapist;
        if (selectedTherapists.length !== 1) {
            notify.warn(t('please_select_a_flypro'));
            return;
        }
        const filteredDomains = await fetchAllDomains();


        const paymentState = {
            selectedTherapist: selectedTherapists,
            address,
            phone,
            origin_flow: 'pro'
        };
        console.log('fypro2', paymentState);
        sessionStorage.setItem('state', JSON.stringify(paymentState));
        if (!auth || Object.keys(auth).length === 0) {
            sessionStorage.setItem('paymentState', paymentState);
            // navigate('/login');
            // return;
        }
        if (filteredDomains.length === 0) {
            notify.warn(t('service_not_served'));
            openModalservice();
            return;
        }

        const newBooking = {
            ...(JSON.parse(sessionStorage.getItem("newBooking") || "{}")),
            therapists: selectedTherapists
        };
        sessionStorage.setItem("newBooking", JSON.stringify(newBooking));

        navigate('/flypro-service', {
            state: paymentState
        });
    };
    function addedTherapist(therapist) {
        setSelectedTherapist((prevTherapists) => {
            const isAlreadySelected = prevTherapists.some(t => t.id === therapist.id);

            if (isAlreadySelected) {
                return [];
            }
            return [therapist];
        });
    }
    useEffect(() => {
        // Try to get address from different sources
        let savedAddress = sessionStorage.getItem('address');
        let addressObj = null;

        try {
            addressObj = savedAddress ? JSON.parse(savedAddress) : null;
        } catch (e) {
            console.error("Error parsing address from sessionStorage:", e);
        }

        if (!addressObj) {
            const stateStr = sessionStorage.getItem('state');
            if (stateStr) {
                try {
                    const stateObj = JSON.parse(stateStr);
                    addressObj = stateObj?.address || null;
                } catch (e) {
                    console.error("Error parsing state from sessionStorage:", e);
                }
            }
        }

        console.log("Address object:", addressObj);
        setAddress(addressObj);
        fetchTherapists(addressObj);

        const savedPhone = sessionStorage.getItem('phone');
        if (savedPhone) {
            try {
                setPhone(JSON.parse(savedPhone));
            } catch (e) {
                console.error("Error parsing phone from sessionStorage:", e);
            }
        }
    }, []);

    return (
        <div className="flypro-favorites-page booking-therapist-page booking-therapist-page--flypro">
            <Header className="header--flypro-flow" compactLanguage />
            <div className={`container ${!modalIsOpen2 && 'container-therapeut'}`}>
                {!modalIsOpen2 && <h2>{t('fav:choose_your_favorite_therapist')}</h2>}
            </div>
            <form className="form-masseur booking-therapist-page__form" onSubmit={handleSubmit}>
                {modalIsOpen2 ? <>
                    <div className="contentModal">

                        <HeaderTherapist currentTherapist={currentTherapist} closeModal2={closeModal2} />
                        <ReviewList currentTherapist={currentTherapist} />
                        <Informations currentTherapist={currentTherapist} axios={api} auth={auth} />
                    </div></> : <>
                    <div className={`container ${!modalIsOpen2 && 'container-therapeut'}`}>
                        {therapists.length > 0 && (<div className="form-group group-masseur">

                            {[...therapists]
                                .sort((a, b) => {
                                    if (a.agent_type === 'EMPLOYEE' && b.agent_type !== 'EMPLOYEE') return -1;
                                    if (a.agent_type !== 'EMPLOYEE' && b.agent_type === 'EMPLOYEE') return 1;
                                    return 0;
                                })
                                .map((therapist) => (
                                    <div
                                        key={therapist.id}
                                        className="therapist-item"
                                        onClick={() => addedTherapist(therapist)}
                                    >
                                        <img
                                            onClick={() => openModal2(therapist)}
                                            src={therapist.media.length ? therapist.media[0].original_url : user}
                                            alt={therapist?.name}
                                            className="therapist-image"
                                        />
                                        <div className="therapist-info">
                                            <p className="name">
                                                <span className="flypro-card-meta__name-text">{therapist?.firstname}</span>
                                                <Tooltip title={t('more_info')} placement="top" arrow slotProps={{
                                                    popper: {
                                                        sx: {
                                                            '& .MuiTooltip-tooltip': {
                                                                backgroundColor: '#393d44',
                                                                color: '#fff',
                                                                fontSize: '1rem',
                                                                padding: '8px 12px',
                                                                borderRadius: '8px'
                                                            },
                                                            '& .MuiTooltip-arrow': {
                                                                color: '#393d44',
                                                            }
                                                        }
                                                    }
                                                }}>
                                                    <IconButton
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            openModal2(therapist);
                                                        }}
                                                    >
                                                        <InfoIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </p>
                                            <FlyproCardMetadata therapist={therapist} />
                                            <button
                                                type="button"
                                                className={`btn-outline-primary ${selectedTherapist.some(t => t.id === therapist.id) ? 'selected' : ''}`}
                                            >
                                                &gt;
                                            </button>
                                        </div>
                                    </div>
                                ))}
                        </div>)}</div></>}

                <div className='btn-bottom'>
                    {!modalIsOpen2 ?
                        (
                            <button type="submit" className="btn btn-primary">
                                {t('fav:next')}
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setIsOpen2((prev) => !prev);
                                }}
                            >
                                {t('fav:close')}
                            </button>
                        )
                    }
                </div>

            </form>



            {/* <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className="contentModal">
                    <div className="headerModal modal-icone">
                        <a onClick={closeModal}>
                            <img src={back} alt="Fermer" />
                        </a>
                        <a onClick={closeModal}>
                            <img src={croix} alt="Fermer" />
                        </a>
                    </div>
                    <div className="form-inscription">
                        <form onSubmit={handleSubmitFilter}>
                            <label>Sexe</label>
                            <div className="form-choix">
                                <div className="form-radio">
                                    <input
                                        type="radio"
                                        name="civility"
                                        value="MR"
                                        checked={formData.civility === "MR"}
                                        id="monsieur"
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="monsieur">Homme</label>
                                </div>
                                <div className="form-radio">
                                    <input
                                        type="radio"
                                        name="civility"
                                        value="MS"
                                        id="madame"
                                        checked={formData.civility === "MS"}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="madame">Femme</label>
                                </div>

                            </div>
                            <div className='flex-row gap-10'>
                                <div className="form-text">
                                    <label>Language</label>
                                    <select name="langue" onChange={handleChange}>
                                        <option value="fr">Français</option>
                                        <option value="en">Anglais</option>

                                    </select>
                                </div>
                            </div>
                            <div className='flex-row gap-10'>
                                <div className="form-text">
                                    <label>Niveau d’éxpercience</label>
                                    <select name="niveau" onChange={handleChange}>
                                        <option value="1">Level 1</option>
                                        <option value="2">Level 2</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-button">
                                <button className='btn-submit' type="submit">Filter</button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal> */}

            <Modal
                isOpen={modalIsOpenService}
                onRequestClose={closeModalservice}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className="zone-not-served-container">
                    <div className="popup-box">
                        <button onClick={closeModalservice} className="close-btn"><img src={croix} alt="Fermer" /></button>
                        <h2>{t('fav:nondesservi')}</h2>
                        <p>
                            {t('fav:desole')} </p>
                        <form onSubmit={handleSubmitEmail}>
                            <label htmlFor="email">Adresse email *</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <button type="submit" className="send-btn">{t('fav:envoyer')}</button>
                        </form>
                        <button onClick={onContact} className="support-btn">{t('fav:contacter')}</button>
                    </div>
                </div>
            </Modal>
        </div>

    );
};

export default FavFlyPro;
